/**
 * VideoStreamPlayer registration: the parser, which reuses the Control parse. Property knowledge
 * lives in linterParser.ts, and render wiring in `index.r3f.ts`.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseControl } from '../control/parser';
const videoStreamPlayerRegistration = {
    typeName: 'VideoStreamPlayer',
    parser: parseControl,
};
nodeRegistry.register(videoStreamPlayerRegistration);
//# sourceMappingURL=index.js.map